import { PaginatedList } from '../types/common';
import { InvoicesData } from '../types/invoices';

export const closedInvoiceSampleData: PaginatedList<InvoicesData> = {
  list: [
    {
      id: 11,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0011',
      invoice_title: 'I0011',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 47681.09,
      amount_data: {
        value: 47681.09,
        currency: 'USD',
      },
      amount_base_currency: 47681.09,
      due_date: '2023-10-01',
      status_updated_date: '2023-10-01T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2023-08-17',
      closed_invoice_details: [
        {
          id: 8,
          type: 'PAYMENT',
          date: '2023-10-20',
          amount: 39518.01,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2023-10-20',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 12,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0012',
      invoice_title: 'I0012',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 39518.01,
      amount_data: {
        value: 39518.01,
        currency: 'USD',
      },
      amount_base_currency: 39518.01,
      due_date: '2023-10-11',
      status_updated_date: '2023-10-11T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2023-08-27',
      closed_invoice_details: [
        {
          id: 9,
          type: 'PAYMENT',
          date: '2024-02-02',
          amount: 48433.19,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-02-02',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 8,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0008',
      invoice_title: 'I0008',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 48681.02,
      amount_data: {
        value: 48681.02,
        currency: 'USD',
      },
      amount_base_currency: 48681.02,
      due_date: '2023-10-31',
      status_updated_date: '2023-10-31T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2023-09-16',
      closed_invoice_details: [
        {
          id: 6,
          type: 'PAYMENT',
          date: '2023-11-12',
          amount: 48681.02,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2023-11-12',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 13,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0013',
      invoice_title: 'I0013',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 48433.19,
      amount_data: {
        value: 48433.19,
        currency: 'USD',
      },
      amount_base_currency: 48433.19,
      due_date: '2024-01-28',
      status_updated_date: '2024-01-28T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2023-12-14',
      closed_invoice_details: [
        {
          id: 10,
          type: 'PAYMENT',
          date: '2024-03-30',
          amount: 48462.84,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-03-30',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 5,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0005',
      invoice_title: 'I0005',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 45066.79,
      amount_data: {
        value: 45066.79,
        currency: 'USD',
      },
      amount_base_currency: 45066.79,
      due_date: '2024-02-18',
      status_updated_date: '2024-02-18T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2024-01-04',
      closed_invoice_details: [
        {
          id: 4,
          type: 'PAYMENT',
          date: '2024-01-10',
          amount: 45066.79,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-01-10',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 6,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0006',
      invoice_title: 'I0006',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 43620.4,
      amount_data: {
        value: 43620.4,
        currency: 'USD',
      },
      amount_base_currency: 43620.4,
      due_date: '2024-02-23',
      status_updated_date: '2024-02-23T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2024-01-09',
      closed_invoice_details: [
        {
          id: 5,
          type: 'PAYMENT',
          date: '2024-01-10',
          amount: 43620.4,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-01-10',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
    {
      id: 14,
      currency: 'USD',
      status: 'CLOSED',
      deleted: false,
      invoice_no: 'I0014',
      invoice_title: 'I0014',
      balance_due_amount: 0,
      balance_due_amount_base_currency: 0,
      amount: 48462.84,
      amount_data: {
        value: 48462.84,
        currency: 'USD',
      },
      amount_base_currency: 48462.84,
      due_date: '2024-03-05',
      status_updated_date: '2024-03-05T00:00:00+0000',
      payment_status: 'FULL',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2024-01-20',
      closed_invoice_details: [
        {
          id: 11,
          type: 'PAYMENT',
          date: '2024-04-18',
          amount: 31930.92,
        },
      ],
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-04-18',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      draft_invoice: false,
    },
  ],
  total_records: 7,
  current_page: 1,
  total_pages: 1,
};
